module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer014"
    }
  }, [_c('p', {
    staticClass: "ebook-toc",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer016"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "65%"
    },
    attrs: {
      "alt": "",
      "src": "image/2.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer015"
    }
  }, [_c('p', {
    staticClass: "Normal ParaOverride-4 t"
  }, [_c('span', {
    staticClass: "text-italic"
  }, [_vm._v("Abaya:")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" Arabic word that refers to the long, loose-fitting dress worn by some Muslim women.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-4"
  }, [_c('span', {
    staticClass: "text-italic"
  }, [_vm._v("Allah:")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" the Arabic word for God; the One who created everything and deserves all worship")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-4"
  }, [_c('span', {
    staticClass: "text-italic"
  }, [_vm._v("Aunty:")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" a woman who is middle-aged or older who offers unsolicited advice to anyone in a five-mile radius. Most powerful around other aunties. ")]), _c('span', {
    staticClass: "text-italic"
  }, [_vm._v("Will")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" ask you to marry her son upon first meeting you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-4"
  }, [_c('span', {
    staticClass: "text-italic"
  }, [_vm._v("Bint:")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" Arabic word meaning “daughter of”")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-4"
  }, [_c('span', {
    staticClass: "text-italic"
  }, [_vm._v("Ilm:")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" Arabic word used to describe religious pursuits of knowledge")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-4"
  }, [_c('span', {
    staticClass: "text-italic"
  }, [_vm._v("Islam:")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" a monotheistic faith; the religion of Muslims. The Arabic root of the word means “submission to God.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-4"
  }, [_c('span', {
    staticClass: "text-italic"
  }, [_vm._v("Muslim:")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" a follower of the religion of Islam. Arabic word meaning “one who submits to God.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-4"
  }, [_c('span', {
    staticClass: "text-italic"
  }, [_vm._v("the Prophet (peace be upon him):")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" Prophet Mohammed (pbuh) was the last and final messenger sent by God as a guide for all mankind and to whom the holy Quran was revealed.  ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-4"
  }, [_c('span', {
    staticClass: "text-italic"
  }, [_vm._v("Qadr:")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" destiny that was decreed for us before we were even born but can sometimes be changed by appealing to God through worship, prayer, and good deeds")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-4"
  }, [_c('span', {
    staticClass: "text-italic"
  }, [_vm._v("Quran:")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" the words of God revealed to His prophet, Mohammed (pbuh). The central religious text of Islam. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-4"
  }, [_c('span', {
    staticClass: "text-italic"
  }, [_vm._v("Salam:")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" the shortened greeting Muslims give each other either coming or going. It is an Arabic word meaning “peace.” The full greeting is “assalamu alaikum,” meaning “peace be upon you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-4"
  }, [_c('span', {
    staticClass: "text-italic"
  }, [_vm._v("Shay: ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Arabic word meaning “tea”")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-4"
  }, [_c('span', {
    staticClass: "text-italic"
  }, [_vm._v("Sheikh:")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" a leader in a Muslim community usually known for their knowledge of the religion. Slang: can be used ironically to refer to anyone with vast amounts of knowledge: ")]), _c('span', {
    staticClass: "text-italic"
  }, [_vm._v("ex., Sheikh Google.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-4"
  }, [_c('span', {
    staticClass: "text-italic"
  }, [_vm._v("Shik Shak Shook:")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" popular song by Hassan Abou El Seoud played on repeat at weddings")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-4"
  }, [_c('span', {
    staticClass: "text-italic"
  }, [_vm._v("Yallah:")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" slang Arabic word meaning “come on” or “hurry up”")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-4"
  }, [_c('span', {
    staticClass: "text-italic"
  }, [_vm._v("Zagharit (zaghrouta)")]), _c('span', {
    staticClass: "text-italic"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" celebratory ululations, usually high-pitched and shrill (the more shrill the better)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71de8dea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Arranged_ebook3.vue
// module id = 69
// module chunks = 0